import { createSelector } from '@ngrx/store';

import { getCurrentRoute } from '../getCurrentRoute';

export const isCurrentRouteCollectionTypeUrl = createSelector(getCurrentRoute, (current) => current?.data?.isCollectionTypeUrl || false);
